import * as React from "react";
import { Lightbox } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { ProductAsset } from "../../types/interfaces";
import helpers from "../../_helpers/common";

interface props {
  productAsset: ProductAsset[] | null;
}

const ImageGallery: React.FC<props> = ({ productAsset }) => {
  const [open, setOpen] = React.useState(false);
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  const slides =
    productAsset?.map((img) => ({
      src: img.filepath,
    })) || [];

  return (
    <>
      <div className="d-flex gap-3 flex-wrap">
        {productAsset?.map((item, index) => (
          //Image card
          <div key={index} className="card card-bordered" style={{ width: "180px" }}>
            <div className="card-img-top">
              <img
                src={item.filepath}
                alt={`product-${index}`}
                className="rounded cursor-pointer"
                style={{ width: "100%", height: "120px", objectFit: "cover" }}
                onClick={() => {
                  setCurrentIndex(index);
                  setOpen(true);
                }}
              />
            </div>
          </div>
        ))}
      </div>
      
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={currentIndex}
      />
    </>
  );
};

export default ImageGallery;
